import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Wrench, Facebook } from 'lucide-react';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  // TEMPORARY HIDE FLAG - Use key phrase "SHOW_COMMUNITY_SECTIONS" to restore
  const HIDE_REVIEWS = true;

  const navigation = [
  { name: 'Home', path: '/' },
  { name: 'Services', path: '/services' },
  { name: 'Repair Request', path: '/repair-request' },
  { name: 'Reviews', path: '/reviews', hidden: HIDE_REVIEWS },
  { name: 'Contact', path: '/contact' }];


  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50 transition-all duration-300">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <img 
              src="https://customer-assets.emergentagent.com/job_waste-less-hub-1/artifacts/918kjlll_image.png"
              alt="Repair Cafe Logo"
              className="w-12 h-12 rounded-full transform group-hover:scale-110 transition-transform duration-300"
            />
            <div className="flex flex-col">
              <span className="text-xl font-bold text-[#193460]">Repair Cafe</span>
              <span className="text-sm text-[#E87B6A] font-semibold -mt-1">Peterborough Repair Cafe UK</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            {navigation.filter(item => !item.hidden).map((item) =>
            <Link
              key={item.name}
              to={item.path}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 ${
              isActive(item.path) ?
              'bg-[#E87B6A] text-white shadow-md' :
              'text-[#193460] hover:bg-gray-100'}`
              }>

                {item.name}
              </Link>
            )}
            
            {/* Facebook Icon */}
            <a
              href="https://www.facebook.com/peterboroughrepaircafeuk?mibextid=wwXIfr&rdid=XK3N7EsvPbJVRdwr&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1PFFd2wca5%2F%3Fmibextid%3DwwXIfr#"
              target="_blank"
              rel="noopener noreferrer"
              className="ml-2 p-2 rounded-lg hover:bg-gray-100 transition-colors duration-300"
              aria-label="Visit our Facebook page"
            >
              <Facebook className="w-5 h-5 text-[#1877F2]" />
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg text-[#193460] hover:bg-gray-100 transition-colors duration-300"
            aria-label="Toggle menu">

            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen &&
        <div className="md:hidden pb-4 animate-in slide-in-from-top duration-300">
            {navigation.filter(item => !item.hidden).map((item) =>
          <Link
            key={item.name}
            to={item.path}
            onClick={() => setIsMenuOpen(false)}
            className={`block px-4 py-3 rounded-lg text-base font-medium transition-all duration-300 mb-1 ${
            isActive(item.path) ?
            'bg-[#E87B6A] text-white' :
            'text-[#193460] hover:bg-gray-100'}`
            }>

                {item.name}
              </Link>
          )}
          </div>
        }
      </nav>
    </header>);

};